export const sliderImages = [
  {
    image: "/images/slider1.jpg",
    title: "Welcome to Our School",
    description: "Providing quality education with modern facilities.",
    link: "/about",
  },
  {
    image: "/images/slider2.jpg",
    title: "Cultural Activities",
    description: "Encouraging creativity and cultural development.",
    link: "/events",
  },
  {
    image: "/images/slider3.jpg",
    title: "Sports Programs",
    description: "Building healthy bodies and strong minds.",
    link: "/sports",
  },
];

export const visionImages = {
  first: "/images/vision1.jpg",
  second: "/images/vision2.jpg",
  third: "/images/vision3.jpg"
};

export const differenceSection = {
  first: "/images/pic1.jpeg",
  second: "/images/pic2.jpeg",
  teacher: "/images/teacher.png",
  school: "/images/school.png",
  end: "/images/educator-img3.png"
};

export const FacilitiesImages = {
  check: "/images/check-box.png",
  circle1: "/images/circle1.jpg",
  circle2: "/images/circle2.jpg",
  firstbox: "/images/educator-img4.png",
  secondbox: "/images/educator-img3.png",
};

export const principalMessage = {
  prinMasBg: "/images/educator-img7.png",
};

export const latestNews = {
  sideImage: "/images/educator-img3.png",
};

export const latestNewsSliderImages = Array.from(
  { length: 9 },
  (_, i) => `/images/img${i+1}.jpg`
);

export const introImages = {
  bg: "/images/slider1.jpg",
  teacher: "/images/teacher.png",
  school: "/images/school.png"
};

export const teacherImages = {
  sideimg: "/images/educator-img4.png",
};

export const ContactImages = {
  sideImage1: "/images/educator-img4.png",
  sideImage2: "/images/educator-img5.png",
};

export const galleryImages = Array.from(
  { length: 101 },
  (_, i) => `/images/Gallery/img (${i + 1}).jpg`
);

export const ContactSectionData = {
  heading: "Feel Free To Contact And Reach Us!",
  info: [
    {
      id: 1,
      label: "Phone Number:",
      value: "(048) 3259773",
      icon: "/images/phone-call.png",
    },
    {
      id: 2,
      label: "Whatsapp Number:",
      value: "03006007600",
      icon: "/images/whatsapp.png",
    },
    {
      id: 3,
      label: "Location Address:",
      value: "Officers Colony Faisalabad Road, Sargodha, Pakistan",
      icon: "/images/pin.png",
    },
    {
      id: 4,
      label: "Email Address:",
      value: "theharvardschool@yahoo.com",
      icon: "/images/email.png",
    },
  ],
  sideImage1: "/images/educator-img4.png",
  sideImage2: "/images/educator-img5.png",
};

export const fixedSection = {
  whatsappLogo: "/images/wa.png"
};
